<template>
  <div class="relative w-full select-none mt-4 mb-4">
    <ol class="relative z-1 flex items-start">
      <transition-group name="fade" tag="div" class="flex items-start">
      <li v-for="n in total" :key="n" class="flex flex-row items-center text-center relative">
        <div class="border border-solid rounded-[100px] w-fit text-caption-small whitespace-nowrap md:pl-2 md:pr-[10px] md:py-1 flex justify-center items-center flex-nowrap gap-1 "
             :class="n < clampedStep
        ? 'bg-green-10 border-green-dark text-black w-5 h-5 lg:w-auto md:h-auto'
        : n === clampedStep
        ? 'bg-[#fff] border-[#000] text-black pl-2 pr-[10px] py-[2px] lg:py-1'
        : 'bg-[#fff] border-gray text-gray w-5 h-5 md:w-auto md:h-auto'">
        <IconCheck color="#47851E" class="mr-0 md:mr-1" v-if="n < clampedStep" /><span class="text-caption-small md:hidden px-[6px]" v-if="n >= clampedStep" v-html="getText(n)"></span><span class="text-caption-small hidden md:block" v-html="getTextDesktop(n)"></span></div>
        <div
          class="h-[1px] transition-all w-[6px] lg:w-[12px]"
          :class="n < clampedStep
            ? 'bg-[#47851E]'
            : n === clampedStep
              ? 'bg-[#9D9D9C]'
              : 'bg-[#9D9D9C]'"
          role="progressbar"
          aria-valuemin="1"
          aria-valuemax="5"
          :aria-valuenow="clampedStep"
          v-if="n != total"
        >
        </div>
      </li>
      </transition-group>
    </ol>
  </div>
</template>



<script>
import IconCheck from '@/components/icons/IconCheck';
export default {
  name: 'StepwizzardErrorReport',
  components: {IconCheck},
  props: {
    activeStep: Number,
    stepName: String,
    steps: {
      type: Array,
      default: [],
    },
   },
  data() {
    return {
      active: 1,
      originalTexts: ['Var är felet?', 'Vad är felet?', 'Beskrivning', 'Foto', 'Tillträde', 'Granska'],
      texts: ['Var är felet?', 'Vad är felet?', 'Beskrivning', 'Foto', 'Tillträde', 'Granska']
    };
  },

  watch: {
    steps: {
      handler(newSteps) {
        if (!newSteps || newSteps.length == 0) return;
        let updatedTexts = [...this.originalTexts];
        let found = false;

        newSteps.forEach((step) => {
          if (step.step === 'access') {
            found = true;
          }
        });

        if (!found) {
          const index = updatedTexts.indexOf('Tillträde');
          if (index > -1) updatedTexts.splice(index, 1);
        }

        this.texts = updatedTexts;
      },
      immediate: true,
      deep: true
    },
  },

  methods: {
    getText(n) {
      if (n == this.clampedStep) return n + ". " + this.texts[n-1];
      return n;
    },
    getTextDesktop(n) {
      return n + ". " + this.texts[n-1];
    },
  },
  computed: {
    total() { return this.texts.length; },

    clampedStep() {
      switch(this.stepName){
        case 'areaCode':
          return 1;
        case 'rentalObjectCode':
          return 1;
        case 'locationCode':
          return 1;
        case 'partCode':
          return 2;
        case 'subPartCode':
          return 2;
        case 'description':
          return 3;
        case 'photos':
          return 4;
        case 'access':
          return 5;
        case 'confirmation':
          return 6;
        case 'confirm':
          return 6;
        default:
          return 1;
      }
//      return Math.min(Math.max(1, Math.round(this.activeStep)), this.total)
    }
  },

};
</script>
